<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      <span :class="$style['card__text--accent']">住宅購入資金の負担を軽減</span
      >させる方法はあるの？
    </template>
    <template #detail>
      住宅ローン控除の活用や将来的には繰り上げ返済をするなどして金利負担を軽減させたいけど、どんなメリット・デメリットがあるのか知りたい。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
